import { createClient as createSupabaseClient } from '@supabase/supabase-js'

import { fetchWithSupabaseDeadline } from './deadline-fetch'

function createAnonClient() {
  return createSupabaseClient(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
    {
      global: {
        fetch: fetchWithSupabaseDeadline,
      },
    }
  )
}

let browserClient: ReturnType<typeof createAnonClient> | undefined

export function createClient() {
  if (typeof window === 'undefined') return createAnonClient()

  browserClient ??= createAnonClient()
  return browserClient
}
